import { createStructuredSelector } from 'reselect';

import { fetchGAWState } from './LoadingPageSelectors';

export const selectSearchLoadMoreApi = (state) => {
  const { searchLoadMoreApi } = fetchGAWState(state);
  return searchLoadMoreApi;
};

export const selectSearchCharityData = (state) => {
  const { searchCharity } = fetchGAWState(state);
  return searchCharity.data;
};

export const selectCharitySaved = (state) => {
  const { charitySaved } = fetchGAWState(state);
  return charitySaved;
};

export const searchTableDerivedStates = createStructuredSelector({
  updatedCounterData: selectSearchLoadMoreApi,
  updatedSearchData: selectSearchCharityData,
  charitySaved: selectCharitySaved,
});
